import { enumChartRenderOrder } from "../constants";
import { QElement } from "./QElement";
import { QRect } from "./QRect";
import { SVG_DrawLine } from "../utils/SVG_DrawLine";
import { XML_DrawLine } from "../utils/XML_DrawLine";

export class QAuxLineElement extends QElement {
  constructor() {
    super();
    this.fControlPoints = null;
    this.fParentPanel = null;
    this.fLayout = null;
    this.fStyle = {
      strokeStyle: "#4399CC",
      dashLine: true,
      lineWidth: 1
    };
    this.fAcceptsClicks = false;
  }

  InitAuxLine(layout) {
    this.fLayout = layout;
  }

  UpdateAuxLineElement(parentPanel) {
    this.fParentPanel = parentPanel;
    //No element type is set.
    this.SetZPlane(enumChartRenderOrder.groups);
  }

  UpdateControlPoints(ctrlPoints) {
    if (!this.fControlPoints) {
      this.fControlPoints = [];
    }
    this.fControlPoints.length = 0;

    if (!ctrlPoints) {
      return;
    }

    this.fControlPoints = ctrlPoints.slice(0);
  }

  UpdateDimensions() {
    this.UpdateHeight();
    this.UpdateWidth();
  }

  UpdateWidth() {
    if (!this.fControlPoints || this.fControlPoints.length < 2) {
      this.SetWidth(0);
      return;
    }
    var max = Math.max.apply(
      Math,
      this.fControlPoints.map(function (o) {
        return o.x;
      })
    );
    var min = Math.min.apply(
      Math,
      this.fControlPoints.map(function (o) {
        return o.x;
      })
    );
    this.SetWidth(max - min);
  }

  UpdateHeight() {
    if (!this.fControlPoints || this.fControlPoints.length < 2) {
      this.SetHeight(0);
      return;
    }
    var max = Math.max.apply(
      Math,
      this.fControlPoints.map(function (o) {
        return o.y;
      })
    );
    var min = Math.min.apply(
      Math,
      this.fControlPoints.map(function (o) {
        return o.y;
      })
    );
    this.SetHeight(max - min);
  }

  SetLayout(layout) {
    this.fLayout = layout;
  }

  GetLayout() {
    return this.fLayout;
  }

  /**
   * @return {boolean}
   */
  IsSelectable() {
    return false;
  }

  /**
   * @return {number}
   */
  GetPositionX() {
    var layout = this.GetLayout();
    var layoutX = layout.GetPositionX();
    if (this.fControlPoints.length > 0) {
      var min = Math.min.apply(
        Math,
        this.fControlPoints.map(function (o) {
          return o.x;
        })
      );
      return layoutX + min;
    }
    return layoutX;
  }

  /**
   * @return {number}
   */
  GetPositionY() {
    var layout = this.GetLayout();
    var layoutY = layout.GetPositionY();
    if (this.fControlPoints.length > 0) {
      var min = Math.min.apply(
        Math,
        this.fControlPoints.map(function (o) {
          return o.y;
        })
      );
      return layoutY + min;
    }
    return layoutY;
  }

  /**
   * @return {boolean}
   */
  IsShown() {
    return true;
  }

  DoRenderElement(drawBuffer) {
    this.DoRenderAuxLineElement(drawBuffer, null);
  }

  DoRenderAuxLineElement(drawBuffer, altCanvasElement) {
    if (!this.fControlPoints || this.fControlPoints.length < 2) {
      return;
    }

    //    var fillStyle = "rgba(" + this.fColor[0] + ", " + this.fColor[1] + ", " + this.fColor[2] + ", " + this.fColor[3] + ")";
    var fillStyle = "rgbA( 200, 12, 12, 0.5)";
    var layout = this.GetLayout();
    var xOffset = layout.GetPositionX();
    var yOffset = layout.GetPositionY();

    if (drawBuffer !== null) {
      var ctx = drawBuffer.getContext("2d");
      ctx.strokeStyle = this.fStyle.strokeStyle;
      ctx.fillStyle = fillStyle;
      ctx.lineWidth = this.fStyle.lineWidth;
      ctx.lineJoin = "miter";
      ctx.beginPath();
      var numPoints = this.fControlPoints.length;
      var point = this.fControlPoints[0];
      ctx.moveTo(point.x + xOffset, point.y + yOffset);
      for (var i = 1; i < numPoints; i++) {
        point = this.fControlPoints[i];
        ctx.lineTo(point.x + xOffset, point.y + yOffset);
      }
      //ctx.closePath();
      if (this.fStyle.dashStyle) {
        ctx.setLineDash([6, 2]);
      }
      ctx.stroke();
      ctx.setLineDash([]);
      //ctx.fill();
    } else {
      //var linkBookmark = cb.GetLinkBookmark();
      var layer = this.GetLayer();
      //XML_DrawLargeSubchartArrow(x0, x1, x2, x3, x4, y0, y1, y2, fs, altCanvasElement, linkBookmark, layer);
    }
  }

  GetLineRect(r, c) {
    var layout = this.GetLayout();
    var thickness = 1;
    var xOffset = layout.GetPositionX();
    var yOffset = layout.GetPositionY();
    var start = this.fControlPoints[c];
    var end = this.fControlPoints[c + 1];
    var x = start.x + xOffset;
    var y = start.y + yOffset;
    var x2 = end.x + xOffset;
    var y2 = end.y + yOffset;
    r.fLeft = x;
    r.fRight = x2;
    r.fTop = y;
    r.fBottom = y2;
    if (this.fHorzOrientation) r.fBottom = r.fBottom + thickness;
  }

  //=================================================================================================
  DoAltRender(altCanvas) {
    if (!this.fControlPoints || this.fControlPoints.length < 2) {
      return;
    }
    var numLines = this.fControlPoints.length - 1;
    //var thickness = this.fStyle.lineWidth;
    var thiccness = 1;
    var lineColor = "#FF0000";
    var dashed = 1;
    for (var c = 0; c < numLines; c++) {
      var r = new QRect();
      var altCanvasType = altCanvas.GetCanvasType();
      var altCanvasElement = altCanvas.GetCanvasElement();

      switch (altCanvasType) {
        case "SVG":
          this.GetLineRect(r, c);
          SVG_DrawLine(
            r.fLeft,
            r.fTop,
            r.fRight,
            r.fBottom,
            lineColor,
            thiccness,
            dashed,
            false,
            altCanvasElement
          );
          break;
        case "XML":
          this.GetLineRect(r, c);
          var theLayer = this.GetLayer();
          XML_DrawLine(
            r.fLeft,
            r.fTop,
            r.fRight,
            r.fBottom,
            lineColor,
            thiccness,
            dashed,
            altCanvasElement,
            theLayer
          );
          break;
      }
    }
  }
}
